import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    makeStyles,
    IconButton,
    AppBar,
    InputBase,
    Divider,
    ListItem,
    List
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { connect } from 'react-redux';
import Highlighter from "react-highlight-words";
import { getAllLocationsForProfile,getAllLocationsForStates } from '../../../store/actions/homeActionCreator';
import * as logger from '../../../logger';

const useStyles = makeStyles((theme) => ({
    iconButton: {
        color: '#9ea0a5',
        fontSize: 18
    },
    divTitle: {
        fontSize: 20,
        fontWeight: 'bold'
    },
    dialogTitleV1: {
        paddingTop: 12,
        paddingBottom: '16px !important',
        paddingRight: 0,
        paddingLeft: 0
    },
    divV1: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: 24,
        paddingRight: 24,
    },
    paperWidth: {
        width: 448,
        height: 665,
        maxWidth: 448,
        maxHeight: 665
    },
    paper1: {
        borderRadius: 4
    },
    appBar: {
        marginTop: 14,
        display: 'flex',
        justifyContent: 'center',
        height: 72,
        backgroundColor: '#f1f1f3',
        boxShadow: 'none',
        paddingLeft: 24,
        paddingRight: 24
    },
    inputV1: {
        backgroundColor: 'white',
        height: 40,
        width: '100%',
        borderRadius: 8,
        '& .MuiInputBase-input': {
            paddingLeft: 16,
            paddingRight: 16
        }
    },
    searchIcon: {
        color: 'grey',
        fontSize: 26,
        marginRight: 6
    },
    dialogContentV1: {
        paddingTop: 0,
        paddingBottom: 24,
        paddingLeft: 8,
        paddingRight: 8
    },
    listItemV1: {
        paddingBottom: '16px !important',
        paddingTop: '16px !important',
        display: 'flex',
        flexDirection: 'column'
    },
    divV2: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    },
    divName: {
        fontSize: 16,
        fontWeight: 'bold'
    },
    textV1: {
        color: '#5170f0',
        backgroundColor: 'white',
        padding: 0
    }
}));

const StateSelectionDialog = ({ open, onClose, onSelect, user, dispatchGetAllLocationsForProfile }) => {

    const [dialogOpen, setDialogOpen] = useState(open);
    const [stateList, setStateList] = useState([]);
    const [searchText, setSearchText] = useState("");

    const classes = useStyles();

    useEffect(() => {

        if (user && user.stateName) {
            setStateList(user.stateName);
        }

    }, [user.stateName]);

    useEffect(() => {
        dispatchGetAllLocationsForProfile(
            () => {
                logger.log("State Selection Dialog Dweb", "------> Get all locations Success ");
            }, () => {
                logger.log("State Selection Dialog Dweb", "------> Get all locations Failure");
            });
    }, [])

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const handleSearch = (text) => {

        setSearchText(text && (text.trim()).length > 0 ? text : "");

        let list = user.stateName;
        let search = text;

        if (text && (text.trim()).length > 0) {
            list = list.filter((listData) => (
                listData && listData.toLowerCase().indexOf(search.toLowerCase()) !== -1
            ))
        }

        setStateList(list);

    }

    const handleListClick = (listData) => {
        onSelect(listData);
        handleClose();
    }

    return (
        <>
            <Dialog
                open={dialogOpen}
                maxWidth="sm"
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
                aria-labelledby="add-driver-dialog-title"
                open={dialogOpen}
                classes={{ paper: classes.paper1, paperWidthSm: classes.paperWidth }}
                onClose={handleClose}
            >
                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divV1}>
                        <div className={classes.divTitle}>
                            Select State
                        </div>
                        <div>
                            <IconButton className={classes.iconButton} onClick={() => handleClose()} >
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </div>

                    <div>
                        <AppBar position="static" className={classes.appBar}>
                            <div>
                                <InputBase
                                    placeholder="Search State"
                                    className={classes.inputV1}
                                    inputProps={{ 'aria-label': 'search' }}
                                    value={searchText}
                                    onChange={(e) => { handleSearch(e.target.value) }}
                                    autoFocus
                                    endAdornment={
                                        <InputAdornment position="start">
                                            <SearchIcon className={classes.searchIcon} />
                                        </InputAdornment>
                                    }
                                />
                            </div>
                        </AppBar>
                    </div>

                </DialogTitle>

                <DialogContent className={classes.dialogContentV1}>
                    <>
                        {stateList && stateList.length > 0 && stateList.map((listData, index) => (
                            <>
                                <List>
                                    <ListItem button className={classes.listItemV1} onClick={() => handleListClick(listData)}>
                                        <div className={classes.divV2}>
                                            <div className={classes.divName}>
                                                {/* {getHighlightedText(listData.name, searchText)} */}
                                                <Highlighter
                                                    highlightClassName={classes.textV1}
                                                    searchWords={[searchText]}
                                                    autoEscape={true}
                                                    textToHighlight={listData}
                                                />
                                            </div>
                                        </div>
                                    </ListItem>
                                    {index != stateList.length - 1 &&
                                        <Divider light className={classes.dividerV1} />
                                    }
                                </List>
                            </>
                        ))
                        }
                    </>
                </DialogContent>

            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchGetAllLocationsForProfile: (onSuccess, onFailure) => { dispatch(getAllLocationsForStates(onSuccess, onFailure)) },
});

export default connect(mapStateToProps, mapDispatchToProps)(StateSelectionDialog);